import {
  GET_ALL_STATIONS_OBSERVATION_DATA,
  GetAllStationsObservationActionType,
  ErrorType 
} from '../../../actions/WeatherStationObservations/StationsList/allStationsObservationActions';

import {
    IStationsObservationsAPIResult
} from "../../../types/APIResponses/WeatherStationObservations/WeatherStationObservationsResponses";
export interface AllStationObservationState {
  allStationObservationDataIsFetching? : boolean;
  allStationObservationData?: IStationsObservationsAPIResult;
  error?: boolean | Record<string, unknown> | unknown;
}

const initialState: AllStationObservationState = {
    allStationObservationDataIsFetching: false,
    allStationObservationData: undefined,
    error: undefined
};

export type AllStationsActionType = ErrorType | GetAllStationsObservationActionType ;

export function allStationsObservation(
    state: AllStationObservationState = initialState, 
    action: AllStationsActionType
): AllStationObservationState {
    switch (action.type)
    {
        case GET_ALL_STATIONS_OBSERVATION_DATA.pending:
        { 
            return {
                ...state,
                allStationObservationDataIsFetching: true
            };
        }
        
        case GET_ALL_STATIONS_OBSERVATION_DATA.fulfilled:
        {
            return {
                ...state,
                error: false,
                allStationObservationData: action.payload as IStationsObservationsAPIResult,
                allStationObservationDataIsFetching: false
            };
        }

        case GET_ALL_STATIONS_OBSERVATION_DATA.rejected:
        {
            return {
                ...state,
                error: action.payload,
                allStationObservationData: undefined,
                allStationObservationDataIsFetching: false
            };
        }
        
        default: 
        {
            return state;
        }
    }
}
